import { createSlice } from '@reduxjs/toolkit';
import {
  fetchLegGroup,
  fetchLegs,
  fetchModule,
  fetchModules,
  fetchPricePermanents,
  fetchTextureType,
} from '../actions/module.action';

const initialState = {
  modules: {
    data: [],
    total: 0,
    isLoading: false,
    isNeedReloadData: false,
  },
  module: {
    data: {},
    isLoading: false,
    isNeedReloadData: false,
  },
  pricePermanents: {
    data: [],
    isLoading: false,
    isNeedReloadData: false,
  },
  textureType: {
    data: [],
    isLoading: false,
    isNeedReloadData: false,
  },
  legGroup: {
    data: [],
    isLoading: false,
    isNeedReloadData: true,
  },
  legs: {
    cabinet_leg_default: null,
    data: [],
    isLoading: false,
    isNeedReloadData: false,
  },
};

export const moduleReducer = createSlice({
  name: 'Module',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchModules.pending, (state, action) => {
        const { offset } = action.meta.arg;
        if (offset === 0) state.modules.data = [];
        state.modules.isLoading = true;
        state.modules.isNeedReloadData = false;
      })
      .addCase(fetchModules.fulfilled, (state, action) => {
        if (action.payload) {
          const { data, total } = action.payload;
          state.modules = {
            ...state.modules,
            data: [...state.modules.data, ...(data ?? [])],
            isLoading: false,
            total,
          };
        }
      })
      .addCase(fetchModules.rejected, state => {
        state.modules = { ...state.modules, isLoading: false };
      })
      .addCase(fetchPricePermanents.pending, state => {
        state.pricePermanents.isLoading = true;
        state.pricePermanents.isNeedReloadData = false;
      })
      .addCase(fetchPricePermanents.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.pricePermanents = {
            ...state.pricePermanents,
            data,
            isLoading: false,
          };
        }
      })
      .addCase(fetchPricePermanents.rejected, state => {
        state.pricePermanents = { ...state.pricePermanents, isLoading: false };
      })
      .addCase(fetchModule.pending, state => {
        state.module = {
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchModule.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.module = {
            ...state.module,
            isLoading: true,
            data,
          };
        }
      })
      .addCase(fetchModule.rejected, state => {
        state.module = { ...state.module, isLoading: false };
      })

      .addCase(fetchTextureType.pending, state => {
        state.textureType = {
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchTextureType.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.textureType = {
            ...state.textureType,
            isLoading: true,
            data,
          };
        }
      })
      .addCase(fetchTextureType.rejected, state => {
        state.textureType = { ...state.textureType, isLoading: false };
      })
      .addCase(fetchLegGroup.pending, state => {
        state.legGroup = {
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchLegGroup.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.legGroup = {
            ...state.legGroup,
            data,
            isLoading: false,
          };
        }
      })
      .addCase(fetchLegGroup.rejected, state => {
        state.legGroup = { ...state.legGroup, isLoading: false };
      })
      .addCase(fetchLegs.pending, state => {
        state.legs = {
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchLegs.fulfilled, (state, action) => {
        if (action.payload) {
          const { data } = action.payload;
          state.legs = {
            ...state.legs,
            data,
            isLoading: false,
            data,
          };
        }
      })
      .addCase(fetchLegs.rejected, state => {
        state.legs = { ...state.legs, isLoading: false };
      });
  },
});

export default moduleReducer.reducer;
